import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { updateProjectSettings, addLeaderboardNavItem } from '@/store/slices/project';
import { getWorkingProject } from '@/store/slices/project/selectors';
import { NavMainItems } from '@/types/homepage.types';
import { EventSettings } from '@/types/projects.types';
import { checkRegistrationToggled } from '@/utils/registration/check-registration-toggled';
import Container from '@ui/container/container';
import Switch from '@ui/switch/switch';
import Text from '@ui/text/text/text';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastContainerIds } from '@ui/toast/toast.types';

const LeaderboardSettings = () => {
  const dispatch = useAppDispatch();
  const workingProject = useAppSelector(getWorkingProject);

  const leaderboardEnabled = !!workingProject?.settings.leaderboard_settings?.enabled;

  const toggleLeaderboard = (on: boolean) => {
    if (workingProject) {
      // registration required for leaderboard feature
      if (on) {
        if (!workingProject.registration_on) {
          checkRegistrationToggled(true, workingProject, dispatch);

          toastTrigger(
            <div>
              <Text tag="h6">Registration Turned On</Text>
              <Text tag="p">
                Enabling the Leaderboard feature requires attendees to register, including first and last name.
              </Text>
            </div>,
            { type: 'info', containerId: EToastContainerIds.stacked }
          );
        }

        toastTrigger(
          <div>
            <Text tag="h6">Leaderboard feature enabled</Text>
            <Text tag="p">
              Points will not apply retroactively for previously completed actions. A CSV upload can be used to update
              attendee scores manually.
            </Text>
          </div>,
          { type: 'info', containerId: EToastContainerIds.stacked }
        );
      }

      const projectSettings: EventSettings = {
        ...workingProject.settings,
        leaderboard_settings: {
          ...workingProject.settings.leaderboard_settings,
          enabled: on,
        },
      };
      dispatch(updateProjectSettings({ event_uuid: workingProject.uuid, settings: projectSettings }));

      // create a leaderboard main nav item if it doesn't already exist and leaderboard tracking is turned on
      if (workingProject.homepage?.event_main_nav_items) {
        const hasLeaderboardNavItem = workingProject.homepage.event_main_nav_items.find(
          (ni) => ni.name === NavMainItems.Leaderboard
        );
        if (!hasLeaderboardNavItem && on) {
          const homepageId = workingProject.homepage.homepage;
          dispatch(addLeaderboardNavItem({ eventUuid: workingProject.uuid, homepageId }));
        }
      }
    }
  };

  return (
    <Container background="none" className="flex ai-center margin-b-32">
      <Text className="margin-r-16">Leaderboard</Text>
      <Switch value="leaderboard" on={leaderboardEnabled} onClick={(_, on) => toggleLeaderboard(on)} />
    </Container>
  );
};

export default LeaderboardSettings;
